// One list, used by the Atena panel dropdown and by the digest model picker, so
// the two cannot drift apart.
export const ATENA_MODELS = [
  { value: "ollama:qwen2.5:7b", label: "Ollama · qwen2.5 7b" },
  { value: "ollama:llama3.2:3b", label: "Ollama · llama3.2 3b" },
  { value: "ollama:gemma3:4b", label: "Ollama · gemma3 4b" },
  { value: "ollama:qedara-brain-qwen-v2:latest", label: "Ollama · qedara-brain v2" },
  { value: "claude:claude-sonnet-4-6", label: "Claude · sonnet 4.6" },
  { value: "openai:gpt-4o-mini", label: "GPT · 4o-mini" },
];

export const AUTO_MODEL = { value: "", label: "Auto (după complexitate)" };

export function modelLabel(spec) {
  return ATENA_MODELS.find((m) => m.value === spec)?.label || spec || "—";
}
